import Vue from "vue";
import VueRouter from "vue-router";
import MasterPlate from "../components/MasterPlate";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/Home"
  },
  {
    path: "/",
    component: MasterPlate,
    children: [
      {
        path: "/Home",
        name: "Home",
        component: () => import("@/views/Home")
      },
      {
        path: "/product",
        name: "product",
        component: () => import("@/views/main/product"),
        meta: { menuName: "机场预警" }
      },
      {
        path: "/message",
        name: "message",
        component: () => import("@/views/main/message"),
        meta: { menuName: "机场报文" }
      },
      {
        path: "/self",
        name: "self",
        component: () => import("@/views/main/self"),
        meta: { menuName: "自观数据" }
      },
      {
        path: "/pavement",
        name: "pavement",
        component: () => import("@/views/main/pavement"),
        meta: { menuName: "道面数据" }
      },
      {
        path: "/weather",
        name: "weather",
        component: () => import("@/views/main/weather"),
        meta: { menuName: "天气图" }
      },
      {
        path: "/satellite",
        name: "satellite",
        component: () => import("@/views/main/satellite"),
        meta: { menuName: "卫星图" }
      },
      {
        path: "/radar",
        name: "radar",
        component: () => import("@/views/main/radar"),
        meta: { menuName: "雷达图" }
      }
    ]
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/other/register")
  },
  {
    path: "/permissions",
    name: "permissions",
    component: () => import("@/views/other/permissions")
  },
  {
    path: "/information",
    name: "information",
    component: () => import("@/views/other/information")
  },
  {
    path: "/update",
    name: "update",
    component: () => import("@/views/other/update")
  }
];

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
  mode: "history",
  base: '/app',// process.env.BASE_URL,
  routes
});
export default router;
